import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { pxToRelative, pxToRems } from '@awaze/design-system.utils.react';
const ProseStyled = styled.article `
  font-size: ${({ theme }) => pxToRems(theme.FontTextText300FontSize)};
  line-height: ${({ theme }) => pxToRelative(theme.FontTextText300LineHeight)};

  p {
    margin-top: ${pxToRems(16)};
    margin-bottom: ${pxToRems(16)};
  }

  blockquote {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(20)};
  }

  h1 {
    margin-top: ${pxToRems(32)};
    margin-bottom: ${pxToRems(28)};
  }

  h2 {
    margin-top: ${pxToRems(28)};
    margin-bottom: ${pxToRems(24)};
  }

  h3 {
    margin-top: ${pxToRems(24)};
    margin-bottom: ${pxToRems(20)};
  }

  h4 {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(16)};
  }

  h5 {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(16)};
  }

  h6 {
    margin-top: ${pxToRems(16)};
    margin-bottom: ${pxToRems(12)};
  }

  img {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(20)};
  }

  video {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(20)};
  }

  figure {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(20)};
    > * {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  figure figcaption {
    margin-top: ${pxToRems(12)};
  }

  pre {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(20)};
  }

  ul,
  ol {
    margin-top: ${pxToRems(20)};
    margin-bottom: ${pxToRems(20)};
    padding-left: 0;
  }

  ol {
    counter-reset: li;
  }

  li {
    margin-top: ${pxToRems(8)};
    margin-bottom: ${pxToRems(8)};
    padding-left: ${pxToRems(20)};
    position: relative;
    list-style-type: none;

    &::before {
      left: ${pxToRems(10)};
      top: 0.75em;
      transform: translate(-50%, -50%);
      position: absolute;
    }
  }

  ul > li {
    &::before {
      content: '';
      border-radius: 50%;
      width: 2.5px;
      height: 2.5px;
      background: ${({ theme }) => theme.ColorGrey800};
    }
  }

  ol > li {
    list-style: none;

    &::before {
      content: counter(li) '.';
      counter-increment: li;
      text-align: center;
      color: ${({ theme }) => theme.ColorGrey800};
    }
  }

  > ul > li p {
    margin-top: ${pxToRems(12)};
    margin-bottom: ${pxToRems(12)};
  }

  > ul > li > *:first-child {
    margin-top: ${pxToRems(20)};
  }

  > ul > li > *:last-child {
    margin-bottom: ${pxToRems(20)};
  }

  > ol > li > *:first-child {
    margin-top: ${pxToRems(20)};
  }

  > ol > li > *:last-child {
    margin-bottom: ${pxToRems(20)};
  }

  ul ul,
  ul ol,
  ol ul,
  ol ol {
    margin-top: ${pxToRems(12)};
    margin-bottom: ${pxToRems(12)};
  }

  hr + * {
    margin-top: 0;
  }

  h2 + * {
    margin-top: 0;
  }

  h3 + * {
    margin-top: 0;
  }

  h4 + * {
    margin-top: 0;
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;
/**
 * A wrapper component to add spacing and default display rules to sections of text.
 *
 * By default `Heading` and `Text` components come with no spacing (this is so they can be used in places and not have to remove unwanted margin/padding).
 *
 * If you want to space them based on our scaling system them simply wrap them in the `Prose` component tag.
 */
export const Prose = ({ children, ...rest }) => {
    return _jsx(ProseStyled, { ...rest, children: children });
};
//# sourceMappingURL=prose.js.map